import { Routes } from '@angular/router';
import { crmLayoutOutletRoute } from '@touch4it/ng-swp/layout-v2';
import { crmGetDetailRoute } from '@touch4it/ng-swp/detail';

import { appGuard } from '~/shared/guards/app.guard';
import { workspaceGuard } from '~/shared/guards/workspace.guard';
import { LogoProvider } from '~/shared/providers/logo.provider';

import { MenuProvider } from './shared/providers/menu.provider';
import { UserProfileProvider } from './features/users/profile/user-profile.provider';
import { UserDetailFormProvider } from './features/users/detail/user-detail-form.provider';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@touch4it/ng-swp/auth').then((a) => a.authRoutes),
  },
  {
    path: 'users/profile',
    canMatch: [appGuard],
    ...crmLayoutOutletRoute({
      path: '',
      providers: [MenuProvider, LogoProvider],
      children: [
        crmGetDetailRoute({
          path: '',
          viewKey: 'user-profile',
          provider: UserProfileProvider,
          providers: [UserDetailFormProvider],
        }),
      ],
    }),
  },
  {
    path: '',
    canMatch: [appGuard],
    children: [
      crmLayoutOutletRoute({
        path: ':workspace',
        canMatch: [workspaceGuard],
        providers: [MenuProvider, LogoProvider],
        children: [
          {
            path: 'workspace',
            loadChildren: () => import('~/features/workspaces/workspace.routes'),
          },
          {
            path: 'knowledgebase',
            loadChildren: () => import('./features/knowledgebase/knowledgebase.routes'),
          },
          {
            path: 'chatrooms',
            loadChildren: () => import('./features/chatrooms/chatrooms.routes'),
          },
          {
            path: 'users',
            loadChildren: () => import('./features/users/users.routes'),
          },
          { path: '**', redirectTo: 'knowledgebase' },
        ],
      }),
    ],
  },
];
